// Unica copia da regra: Reclassificacao (Resolucao CONTRAN 810) so existe com
// dados veiculares completos no Dossie. Usada pelo client, pela guarda legada
// de Laudo e pela regra de criacao da Ordem.
export function canPrepareReclassification(dossier: {
  veiculoId: string | null;
  classificacaoOriginal: string | null;
  ufRegistro: string | null;
}): boolean {
  return !!(
    dossier.veiculoId &&
    dossier.classificacaoOriginal &&
    dossier.ufRegistro
  );
}
